module.exports = __webpack_public_path__ + "img/肖像@2x.34404670.png";